import { RefObject, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import GymAccessCategoryMappingTemplate from '../../templates/GymAccessCategoryMapping/GymAccessCategoryMappingTemplate';

interface chainIdType {
  chainId: string;
}

const MainColumn = (props: { alertRef: RefObject<AlertType> }) => {
  const { accessCategoryId, chainId } = useParams<{ accessCategoryId: string; chainId: string }>();
  const { t } = useTranslation();
  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymAccessCategoryMappingTemplate
        type="new"
        heading={t('ADD_NEW_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      />
    </Card>
  );
};

const AddNewGymAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const { chainId, gymId } = useParams<{ chainId: string; gymId: string }>();

  return (
    <TwoColTemplate
      title={t('ADD_NEW_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} />}
      alertRef={alertRef}
      backButtonHandler={() =>
        history.push(`/gymChains/${chainId}/gyms/${gymId}/gymAccessCategories`)
      }
    />
  );
};

export default AddNewGymAccessCategoryPage;
